<template>
  <div class="pa-connection-list-actions" ref="actions">
    <div class="button add-pod-button" :class="buttonClass" @click.prevent="getNewPod">
      <div class="pa-icon">
        <MeltingPodImage />
      </div>
      <div class="pa-text">
        <p>{{buttonText}}</p>
      </div>
    </div>

    <div class="cancel-button">
      <button
       class="button pa-button pa-cancel-button"
       :disabled="isDisabledCancelButton"
       @click.prevent="handleClickCancel"
      >キャンセル</button>
    </div>
  </div>
</template>

<script>
import MeltingPodImage from '@/components/Parts/PAConnectionManageModal/Images/meltingpod.svg?inlineN'

export default {
  props : {
    isDisabled : {
      default: false
    },

    buttonText : {
      default: 'ポットの取り寄せ'
    }
  },

  components : {
    MeltingPodImage
  },

  data(){
    return {
      buttonClass : {
        'add-pod-button-disabled' : false,
        'is-loading'              : false
      },

      isDisabledCancelButton      : false
    };
  },

  watch : {
    isDisabled(value){
      this.buttonClass['add-pod-button-disabled'] = value;
      this.isDisabledCancelButton = value;
    }
  },

  methods : {
    offsetHeight(){
      return this.$refs.actions.offsetHeight;
    },
    
    getNewPod(){
      if(this.isDisabled === true) return;
      
      this.$emit('clickSubmit');
    },

    handleClickCancel(){
      this.$emit('clickCancel');
    }
  }
}
</script>

<style lang="scss">
.pa-connection-list-actions{
  position: relative;
  margin-top:.5rem;

  .add-pod-button{
    color:#5E3717;
    background-color: #C49065;
    border:2.4px solid #A4734B;
    border-radius: 18px;
    margin:0 .5rem 0 auto;
    padding:0;
    font-size:1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    width:180px;

    .pa-icon{
      vertical-align: middle;
      line-height: 1;

      svg{
        margin-top:.2rem;
        width:auto;
        height: 1.5rem;

        .a{fill:#5e3717;}
      }
    }
    
    &.is-loading{
      .pa-icon{
        svg path{
          fill: #B08968;
        }
      }
    }

    &.is-loading::after{
      border: 2px solid #B08968;
      border-right-color: transparent;
      border-top-color: transparent;
    }

    .pa-text{
      margin-left:.2rem;
      p{
        line-height: 1;
      }
    }

    &-disabled{
      color:#B08968;
      background-color: #B9916F;
      border:2.4px solid #B58A68;

      .pa-icon{
        svg path{
          fill: #B08968;
        }
      }
    }
  }

  .cancel-button{
    position: absolute;
    top:0;
    left:0;

    .pa-cancel-button{
      border: none;
      border-radius: 0;
      padding:0;
      line-height: 1;
      height:inherit;
      border-bottom:1px solid #96735a;
      background-color: inherit;
      font-weight: bold;
      color: #96735a;
      display: block;
      margin: 0 auto;
      padding: 0;
      font-size:.8rem;
      margin-top:1.5rem;
      margin-left:.5rem;
    }
  }
}
</style>